import { UserApi } from './userApi';
import { useConst } from '@chakra-ui/react';
import type { IUserApi } from './userApi';

export const useUserApi = (): IUserApi => {
  return useConst(new UserApi());
};
